import { ReactComponent as MinusSvg } from '../../assets/icons/minus.svg';

export const MinusIcon: SvgIcon = (props) => {
    return <MinusSvg {...props} />;
};
